<template>
  <div class="core requestForm">
    <div class="layui-layer-title" style="cursor: move;">{{ title }}</div>
    <div class="layui-layer-content">
      <div class="layui-layer-wrap">
        <div class="form-collapse">
          <div class="info">
            <layui-form
              ref="tableForm"
              :rule="form_rule"
              :show-form="true"
              :after-save="handleAfterSave"
              requestUniqueId="addWorkOrder"
            >
              <template slot-scope="{ scope }">
                <div class="layui-form">
                  <layui-collapse ref="collapse" class>
                    <div class="layui-colla-item">
                      <h2 class="layui-colla-title">{{ info }}</h2>
                      <div class="layui-colla-content layui-show">
                        <div class="layui-form-item-two layui-form-column">
                          <div class="layui-form-colun-inner">
                            <div class="layui-form-item-left">
                              <div class="pub-form">
                                <div class="layui-form-item">
                                  <label class="layui-form-label"> <span class="x-red">*</span>项目经理名称： </label>
                                  <div class="layui-input-inline" style="width: 65%;" id="manager">
                                    <layui-multiselect
                                      :single="true"
                                      ref="managerSelect"
                                      :enabled="true"
                                      name="MANAGER_ID"
                                      @selectChange="managerChange($event)"
                                      :renderText="renderManagerText"
                                      table-name="YW_MANAGER"
                                      text-field="MANAGER_NAME"
                                      value-field="MANAGER_ID"
                                      :show-null-option="true"
                                      :queryCondition="{}"
                                      :enable-search="true"
                                      :sort="['CREATE_TIME:DESC']"
                                      v-model="scope.editRow.MANAGER_ID"
                                    ></layui-multiselect>
                                  </div>
                                </div>

                                <div
                                  class="layui-form-item"
                                  v-show="type == 'yw' && scope.editRow.REPAIR_STATUS_ID == '10'"
                                >
                                  <label class="layui-form-label">
                                    争议订单：
                                  </label>
                                  <div class="layui-input-inline" style="width: 60%;">
                                    <layui-radio
                                      v-model="scope.editRow.B_DISPUTE_ORDER"
                                      name="B_DISPUTE_ORDER"
                                      :init-value="1"
                                    >
                                      <option value="1" title="是"></option>
                                      <option value="0" title="否"></option>
                                    </layui-radio>
                                  </div>
                                </div>

                                <div class="layui-form-item" v-show="type == 'yw'">
                                  <label class="layui-form-label"> <span class="x-red">*</span>服务方式： </label>
                                  <div
                                    class="layui-input-inline"
                                    style="width: 60%;"
                                    v-show="scope.editRow.B_DISPUTE_ORDER"
                                  >
                                    <layui-radio
                                      v-model="scope.editRow.WORK_ORDER_METHOD"
                                      name="WORK_ORDER_METHOD"
                                      @selectChange="handleMethodSelectChange($event)"
                                    >
                                      <input type="radio" value="1" title="上门服务" />
                                      <input type="radio" value="2" title="远程服务" />
                                      <input type="radio" value="3" title="第三方服务" />
                                      <input type="radio" value="4" title="协商处理" />
                                    </layui-radio>
                                  </div>
                                  <div
                                    class="layui-input-inline"
                                    style="width: 60%;"
                                    v-show="!scope.editRow.B_DISPUTE_ORDER"
                                  >
                                    <layui-radio v-model="scope.editRow.WORK_ORDER_METHOD" name="WORK_ORDER_METHOD">
                                      <input type="radio" value="1" title="上门服务" />
                                      <input type="radio" value="2" title="远程服务" />
                                      <input type="radio" value="3" title="第三方服务" />
                                    </layui-radio>
                                  </div>
                                </div>
                                <div class="layui-form-item" v-show="type == 'gc'">
                                  <label class="layui-form-label"> <span class="x-red">*</span>服务方式： </label>
                                  <div class="layui-input-inline" style="width: 60%;">
                                    <layui-radio v-model="scope.editRow.WORK_ORDER_METHOD" name="WORK_ORDER_METHOD">
                                      <input type="radio" value="1" title="上门服务" />
                                    </layui-radio>
                                  </div>
                                </div>

                                <div class="layui-form-item" v-show="type == 'yw'">
                                  <label class="layui-form-label"> <span class="x-red">*</span>服务请求单来源： </label>
                                  <div class="layui-input-inline" style="width: 60%;" v-show="form_type == 'add'">
                                    <layui-radio v-model="scope.editRow.BILL_SOURCE_METHOD" name="BILL_SOURCE_METHOD">
                                      <input type="radio" value="3" title="微信" />
                                      <input type="radio" value="4" title="电话" />
                                      <input type="radio" value="5" title="钉钉" />
                                      <input type="radio" value="6" title="邮件" />
                                    </layui-radio>
                                  </div>

                                  <div class="layui-input-inline" style="width: 60%;" v-show="form_type != 'add'">
                                    <layui-radio
                                      v-model="scope.editRow.BILL_SOURCE_METHOD"
                                      name="BILL_SOURCE_METHOD"
                                      :enabled="false"
                                    >
                                      <input type="radio" value="1" title="自建" />
                                      <input type="radio" value="2" title="扫码" />
                                      <input type="radio" value="3" title="微信" />
                                      <input type="radio" value="4" title="电话" />
                                      <input type="radio" value="5" title="钉钉" />
                                      <input type="radio" value="6" title="邮件" />
                                    </layui-radio>
                                  </div>
                                </div>

                                <div class="layui-form-item">
                                  <label class="layui-form-label"> <span class="x-red">*</span>服务请求单类型： </label>
                                  <div class="layui-input-inline" style="width: 65%;" v-show="type == 'yw'">
                                    <layui-multiselect
                                      :single="true"
                                      :enabled="true"
                                      :clickClose="true"
                                      name="WORK_ORDER_TYPE"
                                      ref="orderTypeSelect_yw"
                                      table-name="DB_DICTIONARY"
                                      text-field="DIC_NAME"
                                      value-field="DIC_CODE"
                                      id-field="ID"
                                      parent-field="DIC_PCODE"
                                      :show-null-option="true"
                                      :queryCondition="{ DIC_CATEGORY: '工单类型', 'JB:0': '2', 'ID:6': '41245' }"
                                      :enable-search="true"
                                      v-model="scope.editRow.WORK_ORDER_TYPE"
                                    ></layui-multiselect>
                                  </div>
                                  <div class="layui-input-inline" style="width: 65%;" v-show="type == 'gc'">
                                    <layui-multiselect
                                      :single="true"
                                      :enabled="true"
                                      :clickClose="true"
                                      name="WORK_ORDER_TYPE"
                                      ref="orderTypeSelect_gc"
                                      table-name="DB_DICTIONARY"
                                      text-field="DIC_NAME"
                                      value-field="DIC_CODE"
                                      id-field="ID"
                                      parent-field="DIC_PCODE"
                                      :show-null-option="true"
                                      :queryCondition="{
                                        DIC_CATEGORY: '工单类型',
                                        'JB:0': '2',
                                        'ID:3': '41245',
                                        'ID:10': '41456'
                                      }"
                                      :enable-search="true"
                                      v-model="scope.editRow.WORK_ORDER_TYPE"
                                    ></layui-multiselect>
                                  </div>
                                </div>
                                <div class="layui-form-item" v-show="type == 'yw'">
                                  <label class="layui-form-label"> <span class="x-red">*</span>故障类型： </label>
                                  <div class="layui-input-inline" style="width: 65%;">
                                    <layui-multiselect
                                      :single="true"
                                      :enabled="true"
                                      :clickClose="true"
                                      name="WRONG_TYPE"
                                      table-name="DB_DICTIONARY"
                                      text-field="DIC_NAME"
                                      id-field="ID"
                                      parent-field="DIC_PCODE"
                                      value-field="DIC_CODE"
                                      :show-null-option="true"
                                      :queryCondition="{ DIC_CATEGORY: '报修分类', 'JB:5': '2' }"
                                      :enable-search="true"
                                      v-model="scope.editRow.WRONG_TYPE"
                                    ></layui-multiselect>
                                  </div>
                                </div>
                                <div class="layui-form-item">
                                  <label class="layui-form-label"><span class="x-red">*</span>客户：</label>
                                  <div class="layui-input-inline" style="width: 60%;">
                                    <layui-tableselect
                                      ref="clientSelect"
                                      name="STORE_ID"
                                      table-name="YW_CUS_STORE_DETAIL_V1"
                                      @selectChange="clientSelectChange($event)"
                                      @modelChange="clientModelChange($event)"
                                      :renderText="renderClientText"
                                      input-width="100%"
                                      table-width="800px"
                                      text-width="100%"
                                      text-field="STORE_NAME"
                                      value-field="STORE_ID"
                                      queryFields="CLIENT_NAME,STORE_NAME,BRAND_NAME"
                                      v-model="scope.editRow.STORE_ID"
                                      tip="请选择客户"
                                      :sort="['CREATE_TIME:DESC']"
                                      :page-size="50"
                                      :page-range="6"
                                      :page-options="[15, 25, 50, 100]"
                                      style="width:400px"
                                      :beRelated="true"
                                    >
                                      <div>
                                        <div radio="true"></div>
                                        <div field="CLIENT_NAME" title="客户" width="280"></div>
                                        <div field="BRAND_NAME" title="品牌" width="120"></div>
                                        <div field="STORE_NAME" title="门店" width="220"></div>
                                        <div field="MANAGER_NAME" title="项目经理" width="120"></div>
                                        <div field="PROVINCE_DESC" title="省"></div>
                                        <div field="CITY_DESC" title="市"></div>
                                        <div field="DISTRICT_DESC" title="县"></div>
                                      </div>
                                    </layui-tableselect>
                                  </div>
                                  <span class="project-inner-add" @click="addStore()">
                                    <i class="layui-icon layui-icon-add-circle" style="color:#00A0E9 "></i>
                                    新增
                                  </span>
                                </div>
                                <div class="layui-form-item" v-if="type == 'yw'">
                                  <label class="layui-form-label"> <span class="x-red">*</span>SLA等级： </label>
                                  <div class="layui-form-label right" style="width: 60%;">
                                    <layui-multiselect
                                      ref="slaRef"
                                      name="SLA_LEVEL"
                                      :single="true"
                                      text-field="textField"
                                      value-field="valueField"
                                      :initData="slaList"
                                      v-model="scope.editRow.SLA_LEVEL"
                                      :show-null-option="true"
                                      :enable-search="false"
                                    >
                                    </layui-multiselect>
                                    <!-- <layui-radio v-model="scope.editRow.SLA_LEVEL" name="SLA_LEVEL">
                                      <option value="1" title="P0"></option>
                                      <option value="2" title="P1"></option>
                                      <option value="3" title="P2"></option>
                                      <option value="4" title="P3"></option>
                                    </layui-radio> -->
                                    <!-- <label
                                        v-text="scope.editRow.SLA_LEVEL"
                                        style="height: 32px;line-height: 32px;"
                                    ></label> -->
                                  </div>
                                </div>
                                <div class="layui-form-item">
                                  <label class="layui-form-label">客户联系人：</label>
                                  <div class="layui-input-inline" style="width: 65%;">
                                    <input
                                      type="text"
                                      v-model="scope.editRow.CLIENT_PERSON"
                                      autocomplete="off"
                                      class="layui-input"
                                      name="CLIENT_PERSON"
                                      placeholder="请输入客户联系人"
                                    />
                                  </div>
                                </div>
                                <div class="layui-form-item">
                                  <label class="layui-form-label">客户联系人电话：</label>
                                  <div class="layui-input-inline" style="width: 65%;">
                                    <input
                                      type="text"
                                      v-model="scope.editRow.CLIENT_PERSON_PHONE"
                                      autocomplete="off"
                                      class="layui-input"
                                      name="CLIENT_PERSON_PHONE"
                                      placeholder="请输入客户联系人电话"
                                    />
                                  </div>
                                </div>
                                <div class="layui-form-item">
                                  <label class="layui-form-label"><span class="x-red">*</span>描述：</label>
                                  <div class="layui-input-inline" style="width:65%">
                                    <textarea
                                      re
                                      v-model="scope.editRow.DESCRIPTION"
                                      placeholder="请输入相关描述"
                                      name="DESCRIPTION"
                                      class="layui-textarea"
                                    ></textarea>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="layui-form-item-right">
                              <div class="layui-form-item">
                                <label class="layui-form-label"><span class="x-red">*</span>收入金额：</label>
                                <div class="layui-input-inline">
                                  <input
                                    type="number"
                                    min="0"
                                    v-model="scope.editRow.INCOME_AMOUNT"
                                    autocomplete="off"
                                    class="layui-input"
                                    name="INCOME_AMOUNT"
                                    placeholder="请输入收入金额"
                                  />
                                </div>
                              </div>
                              <div class="layui-form-item">
                                <label class="layui-form-label">收入费用状态：</label>
                                <div class="layui-input-inline" style="width: 60%">
                                  <layui-radio v-model="scope.editRow.INCOME_AMOUNT_TYPE" name="INCOME_AMOUNT_TYPE">
                                    <input type="radio" value="1" title="未付款" />
                                    <input type="radio" value="2" title="已付款" />
                                  </layui-radio>
                                </div>
                              </div>
                              <div class="layui-form-item">
                                <label class="layui-form-label">收入票据状态：</label>
                                <div class="layui-input-inline" style="width: 60%">
                                  <layui-radio v-model="scope.editRow.INCOME_BILL_TYPE" name="INCOME_BILL_TYPE">
                                    <input type="radio" value="1" title="未开票" />
                                    <input type="radio" value="2" title="已开票" />
                                  </layui-radio>
                                </div>
                              </div>
                              <div class="layui-form-item">
                                <label class="layui-form-label"><span class="x-red">*</span>支出金额：</label>
                                <div class="layui-input-inline">
                                  <input
                                    type="number"
                                    min="0"
                                    v-model="scope.editRow.EXPENSES_AMOUNT"
                                    autocomplete="off"
                                    class="layui-input"
                                    name="EXPENSES_AMOUNT"
                                    placeholder="请输入支出金额"
                                  />
                                </div>
                              </div>
                              <div class="layui-form-item">
                                <label class="layui-form-label">支出费用状态：</label>
                                <div class="layui-input-inline" style="width: 60%">
                                  <layui-radio v-model="scope.editRow.EXPENSES_AMOUNT_TYPE" name="EXPENSES_AMOUNT_TYPE">
                                    <input type="radio" value="1" title="待请款" />
                                    <input type="radio" value="2" title="待付款" />
                                    <input type="radio" value="3" title="已付款" />
                                  </layui-radio>
                                </div>
                              </div>
                              <div class="layui-form-item">
                                <label class="layui-form-label">支出票据状态：</label>
                                <div class="layui-input-inline" style="width: 60%">
                                  <layui-radio v-model="scope.editRow.EXPENSES_BILL_TYPE" name="EXPENSES_BILL_TYPE">
                                    <input type="radio" value="0" title="劳务" />
                                    <input type="radio" value="1" title="待开票" />
                                    <input type="radio" value="2" title="已开票" />
                                  </layui-radio>
                                </div>
                              </div>
                              <div class="layui-form-item">
                                <label class="layui-form-label">备注：</label>
                                <div class="layui-input-inline">
                                  <div class="layui-input-inline" style="width:100%">
                                    <textarea
                                      v-model="scope.editRow.PAYMENT_NOTE"
                                      placeholder="请输入相关对款付账备注"
                                      name="PAYMENT_NOTE"
                                      class="layui-textarea"
                                    ></textarea>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="layui-form-bottom">
                            <div class="layui-form-item">
                              <label class="layui-form-label">附件：</label>
                              <div class="layui-input-inline" style="width:80%">
                                <layui-listfileupload
                                  ref="fuJian_1"
                                  v-model="scope.editRow.ORDER_FJ_ID"
                                  targetEl=".requestForm"
                                >
                                  <template slot-scope="{ scope }">
                                    <div class="layui-upload">
                                      <button type="button" @click="scope.upload()" class="layui-upload-btn">
                                        <i class="layui-icon layui-icon-addition"></i> 添加文件
                                      </button>
                                      <button
                                        type="button"
                                        @click="handleUpload('fuJian_quote', scope)"
                                        class="layui-upload-btn"
                                        style="margin-left:20px"
                                      >
                                        <i class="layui-icon layui-icon-addition"></i> 资料库上传
                                      </button>
                                      <small class="layui-upload-muted">（单个不超过50M）</small>
                                    </div>
                                  </template>
                                </layui-listfileupload>
                              </div>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label">完工报告：</label>
                              <div class="layui-input-inline" style="width:80%">
                                <layui-listfileupload v-model="scope.editRow.WGBG" targetEl=".requestForm">
                                  <template slot-scope="{ scope }">
                                    <div class="layui-upload">
                                      <button type="button" @click="scope.upload()" class="layui-upload-btn">
                                        <i class="layui-icon layui-icon-addition"></i> 添加文件
                                      </button>
                                      <button
                                        type="button"
                                        @click="scope.uploadFromStorage()"
                                        class="layui-upload-btn"
                                        style="margin-left:20px"
                                      >
                                        <i class="layui-icon layui-icon-addition"></i> 资料库上传
                                      </button>
                                      <small class="layui-upload-muted">（单个不超过50M）</small>
                                    </div>
                                  </template>
                                </layui-listfileupload>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-show="type === 'gc'" class="layui-colla-item bpm-container">
                      <h2 class="layui-colla-title">工程流程详情</h2>
                      <div class="layui-colla-content layui-show">
                        <div class="layui-form-item">
                          <label class="layui-form-label"><span class="x-red">*</span>工程流模板：</label>
                          <div class="layui-input-inline" style="width: 25%">
                            <layui-tableselect
                              name="TEMPLATE_ID"
                              table-name="YW_TEMPLATE"
                              @selectChange="flowChange($event)"
                              @modelChange="flowChange($event)"
                              :renderText="renderTemplateText"
                              input-width="100%"
                              table-width="500px"
                              text-field="TEMPLATE_NAME"
                              value-field="TEMPLATE_ID"
                              queryFields="TEMPLATE_NAME"
                              v-model="scope.editRow.TEMPLATE_ID"
                              :sort="['CREATE_TIME:DESC']"
                              :page-size="10"
                              :page-range="6"
                              :page-options="[10, 20, 50, 100]"
                              style="width:400px"
                              :defaultCondition="{ 'DELETED:0': 0 }"
                            >
                              <div>
                                <div radio="true"></div>
                                <div field="TEMPLATE_NAME" title="模板名称" width="220"></div>
                                <div field="CREATE_TIME" title="创建时间" width="220"></div>
                              </div>
                            </layui-tableselect>
                          </div>
                        </div>
                        <div class="layui-form-item bpm-thumb-box">
                          <label for="" class="layui-form-label">缩略图：</label>
                          <div class="layui-input-inline">
                            <bpm
                              ref="bpm"
                              type="view"
                              :bpmData="bpmInfo.data"
                              class="bpm-slt"
                              style="max-height: 500px;"
                            />
                          </div>
                        </div>
                        <!--                        <div class="layui-form-item show-content">
                          <label for="" class="layui-form-label">总备注：</label>
                          <div class="layui-input-inline" style="width: calc(100% - 180px)">{{ bpmInfo.totalBZ || '-' }}</div>
                        </div>
                        <div class="layui-form-item show-content">
                          <label for="" class="layui-form-label">流程附件：</label>
                          <div class="layui-input-inline bpmFile">
                            <div v-for="item in bpmInfo.classFiles" :key="item.node_name">
                              <span>{{ item.node_name }}</span>
                              <layui-fileupload ref="bpmFile" v-model="item.files" :enabled="false" />
                            </div>
                          </div>
                        </div>-->
                      </div>
                    </div>

                    <div class="layui-colla-item">
                      <div class="layui-colla-item">
                        <h2 class="layui-colla-title">客户信息</h2>
                        <div class="layui-colla-content layui-show">
                          <div class="layui-form-item-two">
                            <div class="layui-form-item-left" style="width: 55%">
                              <div class="layui-form-item">
                                <label class="layui-form-label">客户：</label>
                                <label class="layui-form-label right textarea">{{ clientName }}</label>
                              </div>
                              <div class="layui-form-item">
                                <label class="layui-form-label">门店名称：</label>
                                <label class="layui-form-label right">{{ clientRow.STORE_NAME }}</label>
                              </div>
                              <div class="layui-form-item">
                                <label class="layui-form-label">品牌名称：</label>
                                <label class="layui-form-label right">{{ clientRow.BRAND_NAME }}</label>
                              </div>
                              <div class="layui-form-item">
                                <label class="layui-form-label">店长姓名：</label>
                                <label class="layui-form-label right">{{ clientRow.STORE_MANAGER }}</label>
                              </div>
                              <div class="layui-form-item">
                                <label class="layui-form-label">联系方式：</label>
                                <label class="layui-form-label right">{{ clientRow.STORE_MANAGER_PHONE }}</label>
                              </div>
                              <div class="layui-form-item">
                                <label class="layui-form-label">所属地：</label>
                                <label class="layui-form-label right">{{
                                  (clientRow.PROVINCE ? clientRow.PROVINCE_DESC : '') +
                                    '' +
                                    (clientRow.CITY ? clientRow.CITY_DESC : '') +
                                    '' +
                                    (clientRow.DISTRICT ? clientRow.DISTRICT_DESC : '')
                                }}</label>
                              </div>
                              <div class="layui-form-item">
                                <label class="layui-form-label">地址：</label>
                                <label class="layui-form-label right">{{ clientRow.ADDRESS }}</label>
                              </div>
                              <div class="layui-form-item">
                                <label class="layui-form-label">备注：</label>
                                <label class="layui-form-label right">{{ clientRow.BZ }}</label>
                              </div>
                            </div>
                            <div class="layui-form-item-right" style="width: 45%">
                              <div class="layui-form-item" style="height:100%">
                                <div id="container" class="map-box"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="layui-colla-item" v-show="scope.editRow.WORK_ORDER_METHOD === '2'">
                      <div class="layui-colla-item">
                        <h2 class="layui-colla-title">远程处理结果</h2>
                        <div class="layui-colla-content layui-show">
                          <div class="layui-form-item-one">
                            <div class="layui-form-item">
                              <label class="layui-form-label">是否解决：</label>
                              <div class="layui-input-inline" style="width: 32%;">
                                <layui-radio
                                  v-model="scope.editRow.REMOTE_PROCESS_RESULTS"
                                  name="REMOTE_PROCESS_RESULTS"
                                >
                                  <option value="1" title="是"></option>
                                  <option value="0" title="否"></option>
                                </layui-radio>
                              </div>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label">处理结果描述：</label>
                              <div class="layui-input-inline" style="width:32%">
                                <textarea
                                  v-model="scope.editRow.REMOTE_PROCESS_DESCRIBE"
                                  placeholder="请输入处理结果描述"
                                  name="REMOTE_PROCESS_DESCRIBE"
                                  class="layui-textarea"
                                ></textarea>
                              </div>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label">客户满意度：</label>
                              <div class="layui-input-inline" style="width: 32%;">
                                <layui-radio
                                  v-model="scope.editRow.REMOTE_PROCESS_SATISFACTION"
                                  name="REMOTE_PROCESS_SATISFACTION"
                                >
                                  <option value="1" title="满意"></option>
                                  <option value="2" title="一般"></option>
                                  <option value="3" title="不满意"></option>
                                </layui-radio>
                              </div>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label">处理人：</label>
                              <div class="layui-input-inline" style="width: 32%;">
                                <input
                                  type="text"
                                  disabled
                                  v-model="scope.editRow.REMOTE_PROCESS_PERSON"
                                  autocomplete="off"
                                  class="layui-input"
                                  name="REMOTE_PROCESS_PERSON"
                                  placeholder="请输入处理人"
                                />
                              </div>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label">处理时间：</label>
                              <div class="layui-input-inline" style="width: 32%;">
                                <layui-datetime
                                  :enabled="false"
                                  name="REMOTE_PROCESS_TIME"
                                  v-model="scope.editRow.REMOTE_PROCESS_TIME"
                                  placeholder="处理时间"
                                ></layui-datetime>
                              </div>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label">备注：</label>
                              <div class="layui-input-inline" style="width:32%">
                                <textarea
                                  v-model="scope.editRow.REMOTE_PROCESS_BZ"
                                  placeholder="请输入备注"
                                  name="REMOTE_PROCESS_BZ"
                                  class="layui-textarea"
                                ></textarea>
                              </div>
                            </div>
                            <div class="layui-form-item" style="padding-bottom: 0px;">
                              <label class="layui-form-label">附件：</label>
                              <div class="layui-input-inline" style="width:32%">
                                <layui-listfileupload v-model="scope.editRow.REMOTE_PROCESS_FJ" targetEl=".requestForm">
                                  <template slot-scope="{ scope }">
                                    <div class="layui-upload">
                                      <button type="button" @click="scope.upload()" class="layui-upload-btn">
                                        <i class="layui-icon layui-icon-addition"></i> 添加文件
                                      </button>
                                      <small class="layui-upload-muted">（单个不超过50M）</small>
                                    </div>
                                  </template>
                                </layui-listfileupload>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="layui-colla-item">
                      <h2 class="layui-colla-title">
                        <span>设备信息</span>
                      </h2>
                      <div class="layui-colla-content layui-show">
                        <span style="display:none" id="importWarpper">
                          <form enctype="multipart/form-data" style="margin-top: 20px;margin-bottom:10px;">
                            <div style="margin-left: 8.33333333%;">
                              <input type="file" id="file" accept=".xls,.xlsx" />
                              <div style="margin-top:10px;padding-top:5px">
                                <a
                                  style="cursor:pointer;color: blue"
                                  onclick="window.open('/static/template/设备信息维护表模板.xls')"
                                  class="btn btn-default btn-xs"
                                  ><i class="fa fa-file-excel-o"></i> 下载模板</a
                                >
                              </div>
                              <font color="red" style="margin-top:10px;display: block;">
                                提示：仅允许导入“xls”或“xlsx”格式文件！
                              </font>
                            </div>
                          </form>
                        </span>
                        <div class="device">
                          <div class="layui-form">
                            <div class="operate">
                              <li @click="importExcel('YW_DEVICE')"><i class="layui-icon upload"></i>导入</li>
                              <li @click="add('YW_DEVICE')"><i class="add"></i>添加</li>
                              <li @click="remove('YW_DEVICE')" class=" layui-btn-xs-danger">
                                <i class="remove"></i>删除
                              </li>
                            </div>
                            <div class="layui-table-body layui-table-main">
                              <table class="layui-table layui-form" style="margin:0" ref="deviceTable">
                                <thead style="text-align: center;">
                                  <tr style="background: #F0F0F0!important;">
                                    <td style="width:32px">
                                      <div class="layui-table-cell laytable-cell-checkbox">
                                        <div
                                          class="layui-unselect layui-form-checkbox"
                                          @click="checkAll($event, 'YW_DEVICE')"
                                          lay-skin="primary"
                                          id="YW_DEVICE"
                                          ref="all"
                                        >
                                          <i class="layui-icon layui-icon-ok"></i>
                                        </div>
                                      </div>
                                    </td>
                                    <td style="width:60px">订单日期</td>
                                    <td style="width:60px">订单编号</td>
                                    <td style="width:60px">业务类别</td>
                                    <td style="width:60px">客户</td>
                                    <td style="width:60px">备注</td>
                                    <td style="width:60px">商品编码</td>
                                    <td style="width:60px">商品名称</td>
                                    <td style="width:60px">商品型号</td>
                                    <td style="width:60px">商品品牌</td>
                                    <td style="width:60px">单位</td>
                                    <td style="width:60px">数量</td>
                                    <td style="width:60px">仓库</td>
                                    <td style="width:60px">备注</td>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(u, i) in scope.editRow._SLAVE['YW_DEVICE']" :key="i">
                                    <td style="width:20px">
                                      <div class="layui-table-cell laytable-cell-checkbox">
                                        <div
                                          class="layui-unselect layui-form-checkbox"
                                          :class="{ 'layui-form-checked': u.CHECK }"
                                          @click="check($event, i, 'YW_DEVICE')"
                                          lay-skin="primary"
                                        >
                                          <i class="layui-icon layui-icon-ok"></i>
                                        </div>
                                      </div>
                                    </td>
                                    <td>
                                      <input
                                        type="text"
                                        v-model="u.ORDER_TIME"
                                        autocomplete="off"
                                        name="ORDER_TIME"
                                        class="layui-input"
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="text"
                                        v-model="u.ORDER_ID"
                                        autocomplete="off"
                                        name="ORDER_ID"
                                        class="layui-input"
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="text"
                                        v-model="u.BUSINESS_TYPE"
                                        autocomplete="off"
                                        name="BUSINESS_TYPE"
                                        class="layui-input"
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="text"
                                        v-model="u.CLIENT"
                                        autocomplete="off"
                                        name="CLIENT"
                                        class="layui-input"
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="text"
                                        v-model="u.BZ2"
                                        autocomplete="off"
                                        name="BZ2"
                                        class="layui-input"
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="text"
                                        v-model="u.COMMODITY_ID"
                                        autocomplete="off"
                                        name="COMMODITY_ID"
                                        class="layui-input"
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="text"
                                        v-model="u.COMMODITY_NAME"
                                        autocomplete="off"
                                        name="COMMODITY_NAME"
                                        class="layui-input"
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="text"
                                        v-model="u.COMMODITY_TYPE"
                                        autocomplete="off"
                                        name="COMMODITY_TYPE"
                                        class="layui-input"
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="text"
                                        v-model="u.COMMODITY_BRAND"
                                        autocomplete="off"
                                        name="COMMODITY_BRAND"
                                        class="layui-input"
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="text"
                                        v-model="u.MEASURE"
                                        autocomplete="off"
                                        name="MEASURE"
                                        class="layui-input"
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="text"
                                        v-model="u.NUM"
                                        autocomplete="off"
                                        name="NUM"
                                        class="layui-input"
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="text"
                                        v-model="u.WAREHOUSE"
                                        autocomplete="off"
                                        name="WAREHOUSE"
                                        class="layui-input"
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="text"
                                        v-model="u.BZ"
                                        autocomplete="off"
                                        name="BZ"
                                        class="layui-input"
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="layui-colla-item" v-if="work_method_value === '4'">
                      <h2 class="layui-colla-title">
                        <span>协商处理信息</span>
                      </h2>
                      <div class="layui-colla-content layui-show">
                        <div class="layui-form-item-one">
                          <div class="layui-form-item">
                            <label class="layui-form-label">客户诉求描述：</label>
                            <div class="layui-input-inline" style="width:32%">
                              <textarea
                                v-model="scope.editRow.CUSTOMER_APPEAL_DESCRIPTION"
                                placeholder="请输入客户诉求描述"
                                name="CUSTOMER_APPEAL_DESCRIPTION"
                                class="layui-textarea"
                              >
                              </textarea>
                            </div>
                          </div>
                          <div class="layui-form-item">
                            <label class="layui-form-label">协商处理结果：</label>
                            <div class="layui-input-inline" style="width:32%">
                              <textarea
                                v-model="scope.editRow.DISPUTE_HANDLING_METHOD"
                                placeholder="请输入协商处理结果"
                                name="DISPUTE_HANDLING_METHOD"
                                class="layui-textarea"
                              >
                              </textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </layui-collapse>
                </div>
                <div class="layui-form-btn">
                  <div class="layui-footer">
                    <button class="layui-btn refresh" title="关闭" @click="close()">关 闭</button>
                    <button class="layui-btn" title="保存" @click="saveOrder()">保 存</button>
                  </div>
                </div>
              </template>
            </layui-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bpm from '../bpm/bpm'

/**
 * 服务请求单-编辑
 */
export default {
  name: 'ServiceRequestFrom_V2',
  components: { bpm },
  props: {},
  data() {
    return {
      scrollTop: 0,
      title: '',
      form_type: '',
      info: '',
      form_rule: {
        MANAGER_ID: {
          required: { message: '项目经理不能为空' }
        },
        WORK_ORDER_METHOD: {
          required: { message: '服务方式不能为空' }
        },
        BILL_SOURCE_METHOD: {
          required: { message: '服务请求单来源不能为空' }
        },
        WORK_ORDER_TYPE: {
          required: { message: '服务请求单类型不能为空' }
        },
        WRONG_TYPE: {
          required: { message: '故障类型不能为空' }
        },
        TEMPLATE_ID: {
          required: { message: '工作流程名称不能为空' }
        },
        INCOME_AMOUNT: {
          required: { message: '收入金额不能为空' }
        },
        EXPENSES_AMOUNT: {
          required: { message: '支出金额不能为空' }
        },
        STORE_ID: {
          required: { message: '请选择客户' }
        },
        SLA_LEVEL: {
          required: { message: '请选择SLA等级' }
        },
        DESCRIPTION: {
          required: { message: '描述不能为空' }
        },
      },
      defaultEditRow: {
        WORK_ORDER_TYPE: 1,
        WRONG_TYPE: 1,
        _SLAVE: {
          YW_DEVICE: []
        }
      },
      clientRow: {}, //客户信息
      bpmInfo: {
        totalBZ: '',
        totalFiles: '',
        classFiles: [],
        data: []
      },
      type: 'yw',
      map: null,
      marker: null,
      editRow: {
        WORK_ORDER_METHOD: '1',
        BILL_SOURCE_METHOD: '3',
        INCOME_AMOUNT_TYPE: '1',
        INCOME_BILL_TYPE: '1',
        EXPENSES_AMOUNT_TYPE: '1',
        EXPENSES_BILL_TYPE: '1',
        _SLAVE: {
          YW_DEVICE: []
        }
      },
      storeName: '',
      slaList: [],
      clientName: '',
      work_method_value: ''
    }
  },
  watch: {
    'editRow.WORK_ORDER_METHOD': function(newVal) {
      if (['2', '3'].indexOf(newVal + '') > -1) {
        this.editRow.REMOTE_PROCESS_PERSON = this.security.getUser().getUname()
        this.editRow.REMOTE_PROCESS_TIME = moment().format('YYYY-MM-DD HH:mm:ss')
      }
    }
  },
  mounted() {
    this.tableForm = this.$refs.tableForm
    if (this.tabParam) {
      this.serviceRequest = this.tabParam.serviceRequest
      if (this.tabParam.title) {
        this.title = this.tabParam.title
        this.form_type = this.tabParam.form_type
      }
      this.type = this.tabParam.type
      this.form_rule.TEMPLATE_ID.optional = this.type == 'yw'
      this.form_rule.WRONG_TYPE.optional = this.type == 'gc' //工程单不校验
      this.form_rule.SLA_LEVEL.optional = this.type == 'gc' //工程单不校验
      if (this.type == 'yw') {
        this.info = '服务请求运维单基本信息'
      } else {
        this.info = '服务请求工程单基本信息'
      }
      if (this.tabParam.editRow) {
        //编辑
        this.editRow = this.tableForm.editRow = $.extend(true, {}, this.tabParam.editRow)
        if (this.tableForm.editRow.LNG && this.tableForm.editRow.LAT) {
          var arriveCoor = []
          arriveCoor.push(this.tableForm.editRow.LNG)
          arriveCoor.push(this.tableForm.editRow.LAT)
          this.addMarker(arriveCoor)
        }
        this.editRow._SLAVE = {
          YW_DEVICE: []
        }
        if (this.tabParam.editRow._SLAVE.YW_DEVICE) {
          this.tabParam.editRow._SLAVE.YW_DEVICE.forEach((e, i) => {
            let item = $.extend(true, {}, e)
            item.CHECK = false
            this.editRow._SLAVE.YW_DEVICE.push(item)
          })
        }
      } else {
        // 新增
        this.tableForm.editRow = this.editRow
        this.tableForm.editRow.WORK_ORDER_TYPE = 1
        this.tableForm.editRow.WRONG_TYPE = 1
      }
      this.tableObj = this.tabParam.tableObj
    }
    this.refreshStoreSelect = false
    //监听新增门店
    this.$bus.$on('serviceRequest_inner_addStore', () => {
      this.refreshStoreSelect = true
    })
    var that = this
    $('.core').scroll(function(event) {
      that.scrollTop = $('.core').scrollTop()
    })
  },
  activated() {
    if (this.refreshStoreSelect) {
      this.refreshStoreSelect = false
      this.$refs.clientSelect.tableRef.load()
    }
    if (this.scrollTop) {
      $('.core').animate({ scrollTop: this.scrollTop }, 0)
    }
  },
  methods: {
    /** 上传文件处理程序 */
    handleUpload(source, scope) {
      if (source === 'fuJian_quote') {
        scope.uploadFromStorage()
      }
    },
    renderManagerText(row) {
      if (row) {
        var width = $('#manager').width() - 20 - 12 - 30
        var content = ''
        if (row['MANAGER_PHONE']) {
          content = row['MANAGER_NAME'] + '【' + row['MANAGER_PHONE'] + '】'
        } else {
          content = row['MANAGER_NAME']
        }
        return (
          '<div style="white-space: nowrap;max-width:' +
          width +
          'px;overflow: hidden;" title="' +
          content +
          '">' +
          content +
          '</div>'
        )
      }
    },
    renderClientText(row) {
      if (row) {
        if (!row.STORE_ID) {
          return '--请选择--'
        } else {
          var arr = []
          arr.push('客户【 ' + row['CLIENT_NAME'] + ' 】')
          arr.push('品牌【 ' + row['BRAND_NAME'] + ' 】')
          arr.push('门店【 ' + row['STORE_NAME'] + ' 】')
          this.storeName = arr.join(' ')
          this.clientName = row['CLIENT_NAME']
          return arr.join(' ')
        }
      }
    },
    renderTemplateText(row) {
      if (row) {
        if (!row.TEMPLATE_ID) {
          return '--请选择--'
        } else {
          var arr = []
          arr.push('【 ' + row['TEMPLATE_NAME'] + ' 】')
          this.storeName = arr.join(' ')
          return arr.join(' ')
        }
      }
    },
    //根据项目经理过滤客户信息
    managerChange(row) {
      var MANAGER_ID = ''
      if (row.length > 0) {
        MANAGER_ID = row[0]._row.MANAGER_ID
      }
      this.$refs.clientSelect.tableRef.queryObject.MANAGER_ID = MANAGER_ID
      this.$refs.clientSelect.tableRef.load()
    },

    clientSelectChange(row) {
      this.clientRow = row ? row[0] : {}
      //赋值客户联系人和联系方式
      this.editRow.CLIENT_PERSON = this.clientRow.CLIENT_PERSON_NAME
      this.editRow.CLIENT_PERSON_PHONE = this.clientRow.CLIENT_PERSON_PHONE
      //根据选择的客户，自动赋值客户关联的项目经理
      this.$refs.managerSelect.queryCondition.MANAGER_ID = this.clientRow.MANAGER_ID
      this.$refs.managerSelect.refreshAsyncData()
      this.editRow.MANAGER_ID = this.clientRow.MANAGER_ID

      let brandId = this.clientRow.BRAND_ID
      brandId &&
        this.api
          .queryList(
            'YW_STORAGE_DETAIL',
            { p2: { 'BRAND_ID:0': brandId }, p9: 'BRAND_ID,STORAGE_ID,STORAGE_FILES' },
            'getFilesOfBrand'
          )
          .then(res => {
            let fileList = res.result || []
            let l = []
            fileList.map(i => {
              if (i.STORAGE_FILES) {
                l.push(i.STORAGE_FILES)
              }
            })
            l = l.join(',')
            this.editRow.ORDER_FJ_ID = l
            this.$refs['fuJian_1'].setValue(l)
          })

      //包年的，包月，收入金额赋值0
      if (this.clientRow.BALANCE_TYPE == '1' || this.clientRow.BALANCE_TYPE == '2') {
        this.editRow.INCOME_AMOUNT = 0
      } else if (this.clientRow.BALANCE_TYPE == '3') {
        this.editRow.INCOME_AMOUNT = 150
      }
      //sla 等级展示
      // this.editRow.SLA_LEVEL_DESC = this.clientRow.SLA_LEVEL_DESC;
    },
    clientModelChange(row) {
      this.clientRow = row ? row[0] : {}
      if (this.clientRow.LNG && this.clientRow.LAT) {
        var arriveCoor = []
        arriveCoor.push(this.clientRow.LNG)
        arriveCoor.push(this.clientRow.LAT)
        this.addMarker(arriveCoor)
      } else {
        $('#container').empty()
      }
      if (this.type == 'yw') {
        this.getSlaList(row[0])
      }
      //sla 等级展示
      // this.editRow.SLA_LEVEL_DESC = this.clientRow.SLA_LEVEL_DESC;
    },

    getSlaList(row) {
      this.slaList = []
      let p2 = { BRAND_ID: row.BRAND_ID }
      this.api.queryList('YW_CUSTOMER_BRAND', { p2: p2 }, 'brand_sla').then(response => {
        let result = response.result
        result = result[0]
        if (result && result.SLA_CLUB != '') {
          let data = result.SLA_CLUB.split(',')
          data.forEach((item, ind) => {
            let obj = {}
            obj.textField = obj.valueField = item
            this.slaList.push(obj)
          })
        }
        this.$refs.slaRef.setData(this.slaList)
      })
    },

    /** 流程图选择 */
    flowChange(data) {
      data = data.length > 0 ? data[0] : ''
      let bpmInfo = { ...data, TEMPLATE_NODE: undefined }
      if (data.TEMPLATE_NODE) {
        bpmInfo.data = JSON.parse(data.TEMPLATE_NODE)
      } else {
        bpmInfo.data = []
      }
      this.bpmInfo = bpmInfo

      let t = this.$refs['bpm'].getTplNodeInfo(bpmInfo)
      bpmInfo.totalBZ = t.totalBZ
      if (t.totalFiles) {
        bpmInfo.totalFiles = t.totalFiles
        bpmInfo.classFiles = t.classFiles
      } else {
        // this.$refs['bpmFile'].setValue('')
      }
    },
    handleMethodSelectChange(selectData) {
      this.work_method_value = selectData.value
    },
    saveOrder() {
      let form = this.$refs.tableForm
      let orderTypeSelect = this.type === 'yw' ? this.$refs.orderTypeSelect_yw : this.$refs.orderTypeSelect_gc
      let orderType = form.editRow.WORK_ORDER_TYPE
      let datas = orderTypeSelect.getData()
      for (let i = 0; i < datas.length; i++) {
        let data = datas[i]
        if (data.value == orderType) {
          form.editRow.WORK_ORDER_TYPE_DESC = data.name
        }
      }
      if (this.type == 'yw') {
        form.editRow.WORK_ORDER_CATEGORY = 1
      } else {
        form.editRow.WORK_ORDER_CATEGORY = 2
      }
      //如果是远程服务或电话服务，根据远程处理结果是否解决，修改服务单状态
      if (form.editRow.WORK_ORDER_METHOD != '1' && form.editRow.REMOTE_PROCESS_RESULTS == '1') {
        form.editRow.ORDER_STATE = '6'
      }
      // todo 如果是第三方服务，则属于报修业务，WORK_ORDER_TYPE=101 非IT维修类型
      if (form.editRow.WORK_ORDER_METHOD == '3') {
        form.editRow.WORK_ORDER_TYPE = '101'
        // form.editRow.REPAIR_STATUS_ID = '1';
      }
      //如果是远程服务，且选择未解决；给出弹框提示
      if (form.editRow.WORK_ORDER_METHOD != '1' && form.editRow.REMOTE_PROCESS_RESULTS == '0') {
        this.layer.openConfirm('远程处理未解决，是否将远程服务变为上门服务?', () => {
          form.editRow.ORDER_STATE = '1'
          form.editRow.WORK_ORDER_METHOD = '1'
          form.requestUniqueId = 'remoteToRoomService'
          form.callableSave('YW_WORK_ORDER', true)
        })
      } else {
        if (this.tabParam.requestUniqueId) {
          form.requestUniqueId = this.tabParam.requestUniqueId

          // 协商处理
          if (form.editRow.B_DISPUTE_ORDER && this.work_method_value === '4') {
            form.requestUniqueId = 'disputeOrderService'
          }
        }
        form.callableSave('YW_WORK_ORDER', true)
      }
    },
    handleAfterSave() {
      this.baseComponent.closeComponent(this.tabParam.cloneMenu)
      this.baseComponent.loadComponentByName('serviceRequest')
      if (this.tableObj) {
        this.serviceRequest.tab = this.type
        this.tableObj.pageInfo.pageIndex = 1
        this.tableObj.load()
      }
    },
    close() {
      this.baseComponent.closeComponent(this.tabParam.cloneMenu)
      this.baseComponent.loadComponentByName('serviceRequest')
    },
    // 实例化点标记
    addMarker(arriveCoor) {
      this.map = new AMap.Map('container', {
        resizeEnable: true,
        zoom: 10
      })
      //鹰眼
      this.map.addControl(new AMap.OverView())
      //比例尺
      this.map.addControl(new AMap.Scale())
      //工具条
      this.map.addControl(new AMap.ToolBar())
      this.marker = new AMap.Marker({
        icon: '', //图片ip
        imageSize: '20px',
        position: arriveCoor,
        offset: new AMap.Pixel(-13, -30),
        // 设置是否可以拖拽
        draggable: false,
        cursor: 'move',
        // 设置拖拽效果
        raiseOnDrag: false
      })
      this.marker.setMap(this.map)
      this.map.setFitView()
    },
    //导入设备信息
    importExcel() {
      var that = this
      this.layui.layer.open({
        type: 1,
        area: ['400px', '230px'],
        fix: false,
        //不固定
        maxmin: true,
        shade: 0.3,
        title: '上传数据',
        content: $('#importWarpper').html(),
        btn: ['<i class="fa fa-check"></i> 导入', '<i class="fa fa-remove"></i> 取消'],
        // 弹层外区域关闭
        shadeClose: true,
        btn1: function(index, layero) {
          var file = layero.find('#file').val()
          if (file == '' || (!file.endsWith('.xls') && !file.endsWith('.xlsx'))) {
            that.layer.openAlert('请选择后缀为 “xls”或“xlsx”的文件。')
            return false
          }
          var index = layer.load(2, { shade: false })
          var formData = new FormData()
          formData.append('file', layero.find('#file')[0].files[0])
          $.ajax({
            url: process.env.API_HOST + '/device/uploadDevice?token=' + that.security.getToken(),
            data: formData,
            cache: false,
            contentType: false,
            processData: false,
            type: 'POST',
            success: function(result) {
              layer.closeAll()
              if (result.errorMsg) {
                that.layer.openAlert(result.errorMsg)
                return
              }
              result = result.result
              layer.close(index)
              if (result != '') {
                for (var i in result) {
                  result[i].CHECK = false
                }
                that.editRow._SLAVE.YW_DEVICE = result
                that.tableForm.editRow._SLAVE.YW_DEVICE = result
                that.deviceIsShow = true
                that.$nextTick(() => {
                  that.tableObj.load()
                })
              }
            },
            error: function(err) {
              layer.close(index)
            }
          })
        }
      })
    },
    //全选
    checkAll(e, tableName) {
      if (e.currentTarget.className.indexOf('layui-form-checked') > -1) {
        e.currentTarget.className = 'layui-unselect layui-form-checkbox'
      } else {
        e.currentTarget.className = 'layui-unselect layui-form-checkbox layui-form-checked'
      }
      for (var i = 0; i < this.editRow._SLAVE[tableName].length; i++) {
        if (e.currentTarget.className.indexOf('layui-form-checked') > -1) {
          this.editRow._SLAVE[tableName][i].CHECK = true
        } else {
          this.editRow._SLAVE[tableName][i].CHECK = false
        }
      }
    },
    //选中行
    check(e, i, tableName) {
      if (this.editRow._SLAVE[tableName][i].CHECK) {
        this.editRow._SLAVE[tableName][i].CHECK = false
        this.$refs.all.className = 'layui-unselect layui-form-checkbox'
      } else {
        this.editRow._SLAVE[tableName][i].CHECK = true
        let slaveTable = this.editRow._SLAVE[tableName]
        this.$refs.all.className = 'layui-unselect layui-form-checkbox layui-form-checked'
        for (let i = 0; i < slaveTable.length; i++) {
          if (slaveTable[i].CHECK == false) {
            this.$refs.all.className = 'layui-unselect layui-form-checkbox'
          }
        }
      }
    },
    //新增行
    add(tableName) {
      this.editRow._SLAVE[tableName].unshift({ CHECK: false })
      this.$refs.all.className = 'layui-unselect layui-form-checkbox'
    },
    //删除行
    remove(tableName) {
      var data = this.editRow._SLAVE[tableName]
      var arr = []
      for (var i in data) {
        if (data[i].CHECK) {
          arr.push(data[i])
        }
      }
      if (arr.length < 1) {
        this.layer.openAlert('请至少选择一条记录!')
        return
      }
      this.layer.openConfirm('确定要删除这<span style="color:red">' + arr.length + '</span>条记录吗?', () => {
        for (var i = 0; i < arr.length; i++) {
          data.remove(arr[i])
        }
        if (this.editRow._SLAVE[tableName].length == 0) {
          this.$refs.all.className = 'layui-unselect layui-form-checkbox'
        }
        this.layer.openSuccess('删除成功!')
      })
    },

    //新增门店
    addStore() {
      this.baseComponent.smartLoadComponent('storeForm', {
        tableObj: this.tableObj,
        formType: 'add',
        title: '新增门店',
        from: 'serviceRequestForm'
      })
    }
  }
}
</script>

<style lang="postcss">
.core .bpm-thumb-box {
  display: flex;

  & > .layui-input-inline {
    margin: 0;
    flex: 1;
    width: 0;
    border: 1px solid #ddd;
  }
}

.bpm-container {
  & .bpmFile.layui-input-inline {
    width: calc(100% - 180px);
    & .fileinput-filename {
      width: 150px;
    }
  }
}
</style>
<style scoped>
.device .layui-layout-admin .layui-body {
  background: #f5f5f5;
}
.device .layui-form {
  background: #ffffff;
  position: relative;
}
/* .device .layui-table td{
  padding: 4px 4px !important;
} */
.device .layui-form >>> .layui-input {
  border-color: #ffffff;
  width: 100px;
  padding: 1px;
  text-align: center;
}
.core .operate {
  top: -56px;
}
</style>



// WEBPACK FOOTER //
// src/components/workOrder/serviceRequest/serviceRequestForm_v2.vue